// extracted by mini-css-extract-plugin
module.exports = {"root":"page-block_root__WOP1S","white":"page-block_white__j6lOg","filled":"page-block_filled__saGeQ","title":"page-block_title__dcQRa"};